import { render } from "./VarietiesSearch.vue?vue&type=template&id=220ab7d6&ts=true&lang=pug"
import script from "./VarietiesSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./VarietiesSearch.vue?vue&type=script&setup=true&lang=ts"

import "./VarietiesSearch.vue?vue&type=style&index=0&id=220ab7d6&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__